import { addQueryParam } from 'utils/urlutils';
export const unsafe_cleanLinks = (links, otracker = '') => {
    return links
        .filter(link => Boolean(link) && Boolean(link.brandName) && Boolean(link.brandUrl))
        .map(link => {
        return Object.assign({}, link, { brandUrl: addQueryParam('otracker', otracker, link.brandUrl) });
    });
};
export const buildRenderData = (footerData, otracker) => {
    if (!footerData || !footerData.length)
        return [];
    const cleanedOtracker = `${otracker}_footer`;
    let flatFooterLinksGroups = [];
    for (let i = 0; i < footerData.length; i++) {
        const footerLinkGroup = footerData[i];
        for (const key in footerLinkGroup) {
            if (!footerLinkGroup.hasOwnProperty(key))
                continue;
            const group = footerLinkGroup[key];
            const displayText = group.displayText || '';
            const cleanedLinks = unsafe_cleanLinks(group.brandList || [], cleanedOtracker);
            if (!cleanedLinks.length || !displayText)
                continue;
            flatFooterLinksGroups.push({
                key,
                displayText,
                categoryUrl: group.categoryUrl || '',
                links: cleanedLinks
            });
        }
    }
    return flatFooterLinksGroups;
};
